/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PaymentAPI {

  /**
   * Method that initiate agency budget credit processing
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiPaymentAgencyBudget(
    requestBody: {
      amount: number;
      agency_currency_id: 'CAD' | 'EUR' | 'USD';
    },
  ): CancelablePromise<{
    id: string;
    clientSecret: string;
    amount: number;
    tax: number;
    total: number;
    currency: 'CAD' | 'EUR' | 'USD';
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/payment/agency-budget',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a payment intent in DB. The id to pass is not the stripe ID, but Atdera DB id.
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiPaymentAgencyBudget(
    id: number,
  ): CancelablePromise<{
    id: number;
    stripe_payment_intent_id: string;
    stripe_customer_id: string;
    stripe_invoice_id: string;
    initiator_user_id: number;
    initiator_email: string;
    amount: number;
    tax: number;
    total: number;
    agency_id: number;
    agency_currency: string;
    created_at: string;
    status: string;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/agency-budget/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns all succeeded payment intents requesting DB
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiPaymentAgencyBudgetDbSucceededList(): CancelablePromise<Array<{
    id: number;
    stripe_payment_intent_id: string;
    stripe_customer_id: string;
    stripe_invoice_id: string;
    initiator_user_id: number;
    initiator_email: string;
    amount: number;
    tax: number;
    total: number;
    agency_id: number;
    agency_currency: string;
    created_at: string;
    status: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/agency-budget/db-succeeded-list',
    });
  }

  /**
   * Method that check if customer has been created in stripe, and attach it to agency if exist.
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiPaymentAgencyBudgetStripeCheckCustomer(): CancelablePromise<{
    exist: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment/agency-budget/stripe-check-customer',
    });
  }

  /**
   * Stripe WebHook endpoint used to notify this app that a payment has been done successfull
   * @returns string Default Response
   * @throws ApiError
   */
  public static postApiPaymentAgencyBudgetStripeConfirmationWebhook(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment/agency-budget/stripe-confirmation-webhook',
    });
  }

  /**
   * Method that returns all succeeded payment intents requesting stripe API
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiPaymentAgencyBudgetStripeSucceededList(): CancelablePromise<Array<{
    id: string;
    amount: number;
    currency: string;
    agencyId: number;
    userId: string;
    userEmail: string;
    creationDate: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/agency-budget/stripe-succeeded-list',
    });
  }

  /**
   * Method that returns the stripe public API keys, required to initiate a payement
   * @returns string Default Response
   * @throws ApiError
   */
  public static getApiPaymentStripeApiPublicKey(): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment/stripe-api-public-key',
    });
  }

}
